import {
    AsFoundGreenZoneUpperLimitFormula,
    AsFoundYellowZoneUpperLimitFormula,
    WaterEquivalentTestFlowFormula,
    generateUnitLabel,
    getGasUnit,
    getLeakageRateUnit,
    getLiquidUnit,
    getTemperatureUnit
} from './P51.formula';

export const placeholderText = 'Select Engineering Unit';
export const AsFoundTestTableSectionDataP51 = (selectedTag, formData, regionAlias) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'F1086PressureEngineeringUnit',
                    label: 'Pressure EU',
                    value: formData.F1086PressureEngineeringUnit,
                    isDropdown: true,
                    placeholder: placeholderText,
                    options: [
                        { name: placeholderText, value: '' },
                        { name: 'Barg', value: 'Barg' },
                        { name: 'KPag', value: 'KPag' },
                        { name: 'Psig', value: 'Psig' }],
                    isRequired: true,
                    labelWidth: '57.5%',
                    width: '42.4%',
                    marginLeft: '8px',
                    marginTop: '15px',
                    textAlign: 'center',
                    xs: 6,
                    rootMarginRight: '0px',
                    inputTextAlign: 'center',
                    height: '1.65rem',
                    borderBottom: '0'
                },
                {
                    key: 'F1089GreenZoneUpperLimit',
                    label: `Green Zone Upper Limit (${formData?.F603LeakageRateEngUnit ?? ''})`,
                    value: AsFoundGreenZoneUpperLimitFormula(formData),
                    xs: 6,
                    marginRight: '0.5rem',
                    textAlignLabel: 'end',
                    height: '1.25rem',
                    labelWidth: '100%',
                    width: '74.5%',
                    marginTop: '15px',
                    textAlign: 'center',
                    readOnly: true,
                    isCalculatedNew: true,
                }
            ]
        },
        {
            key: 2,
            fields: [
                {
                    key: 'F1094TemperatureEngineeringUnit',
                    label: 'Temperature EU',
                    value: getTemperatureUnit(regionAlias),
                    inputWidth: '58%',
                    labelWidth: '100%',
                    xs: 6,
                    marginRight: '0',
                    maxLength: '10',
                    readOnly: true,
                    isCalculatedNew: true,
                    width: '71.5%',
                    marginLeft: '8px',
                    borderBottom: '0',
                    height: '1.25rem',
                    textAlign: 'center',
                    textAlignLabel: 'left',
                },
                {
                    key: 'Nodata',
                    isLabel: true,
                    xs: 3,
                },
                {
                    key: 'remark',
                    label: '20x Factory Acceptance Test',
                    isLabel: true,
                    xs: 3,
                    fontWeight: '600',
                    labelWidth: '100%',
                    padding: '1px 0 3px 45px',
                    fontSize: '8.5pt',
                    color: '#ea7c34'
                }]
        },
        {
            key: 3,
            fields: [
                {
                    key: 'F1093TestMedia',
                    label: 'Test Media',
                    value: formData.F1093TestMedia,
                    isDropdown: true,
                    placeholder: 'Select Test Media',
                    options: [
                        { name: 'Select Test Media', value: '' },
                        { name: 'Gas', value: 'Gas' },
                        { name: 'Liquid', value: 'Liquid' }],
                    isRequired: true,
                    labelWidth: '57.5%',
                    width: '42.4%',
                    marginLeft: '8px',
                    textAlign: 'center',
                    xs: 6,
                    rootMarginRight: '0px',
                    inputTextAlign: 'center',
                    height: '1.65rem',
                    borderBottom: '0'
                },
                {
                    key: 'F1090YellowZoneUpperLimit',
                    label: `Yellow Zone Upper Limit (${formData?.F603LeakageRateEngUnit ?? ''})`,
                    value: AsFoundYellowZoneUpperLimitFormula(formData),
                    xs: 6,
                    marginRight: '0.5rem',
                    textAlignLabel: 'end',
                    height: '1.25rem',
                    labelWidth: '100%',
                    width: '74.5%',
                    textAlign: 'center',
                    readOnly: true,
                    isCalculatedNew: true,
                }
            ]
        },
        {
            key: 4,
            fields: [
                {
                    key: 'F603LeakageRateEngUnit',
                    label: 'Leakage Rate EU',
                    value: getLeakageRateUnit(formData.F1093TestMedia, regionAlias),
                    inputWidth: '58%',
                    labelWidth: '100%',
                    xs: 6,
                    marginRight: '0',
                    maxLength: '10',
                    readOnly: true,
                    isCalculatedNew: true,
                    width: '71.5%',
                    marginLeft: '8px',
                    height: '1.25rem',
                    textAlign: 'center',
                    textAlignLabel: 'left',
                },
                {
                    key: 'Nodata2',
                    isLabel: true,
                    xs: 3,
                },
                {
                    key: 'remark2',
                    label: '100x Factory Acceptance Test',
                    isLabel: true,
                    xs: 3,
                    fontWeight: '600',
                    labelWidth: '100%',
                    padding: '1px 0 3px 45px',
                    fontSize: '8.5pt',
                    color: '#ea7c34'
                }]
        },
        {
            key: 5,
            fields: [
                {
                    key: 'F1095TestTemperature',
                    label: `Test Temperature (${formData?.F1094TemperatureEngineeringUnit || ''})`,
                    value: formData.F1095TestTemperature,
                    inputWidth: '58%',
                    labelWidth: '100%',
                    xs: 6,
                    marginRight: '0',
                    marginTop: '15px',
                    maxLength: '10',
                    isRequired: true,
                    width: '71.5%',
                    marginLeft: '8px',
                    borderBottom: '0',
                    height: selectedTag?.WaterPsvReliefCapacity ? '1.25rem' : '1.4rem',
                    type: 'number',
                    textAlign: 'center',
                },
                ...(selectedTag?.NitrogenPsvReliefCapacity ? [{
                    key: 'F1096NitrogenPsvReliefCapacity',
                    label: `Nitrogen PSV Relief Capacity (${getGasUnit(regionAlias)})`,
                    value: selectedTag.DateTested ? formData?.F1096NitrogenPsvReliefCapacity : formData?.F1096NitrogenPsvReliefCapacity ?? selectedTag?.NitrogenPsvReliefCapacity,
                    xs: 6,
                    marginRight: '0.5rem',
                    textAlignLabel: 'end',
                    height: '1.25rem',
                    marginTop: '15px',
                    readOnly: true,
                    isCalculatedNew: true,
                    labelWidth: '100%',
                    width: '74.5%',
                    textAlign: 'center',
                    borderBottom: selectedTag?.WaterPsvReliefCapacity ? '0' : '2',
                    type: 'number',
                    maxLength: '10',
                }] : [])
            ]
        },
        {
            key: 6,
            fields: [
                {
                    key: 'F1087UpstreamPressure',
                    label: generateUnitLabel('Upstream Pressure ', formData),
                    value: formData.F1087UpstreamPressure,
                    inputWidth: '58%',
                    labelWidth: '100%',
                    xs: 6,
                    marginRight: '0',
                    maxLength: '10',
                    isRequired: true,
                    width: '71.5%',
                    marginLeft: '8px',
                    borderBottom: '0',
                    height: formData.F1093TestMedia === 'Gas' && !selectedTag?.NitrogenPsvReliefCapacity ? '1.25rem' : '1.4rem',
                    type: 'number',
                    textAlign: 'center',
                },
                ...(selectedTag?.WaterPsvReliefCapacity ? [{
                    key: 'F1097WaterPsvReliefCapacity',
                    label: `Water PSV Relief Capacity (${getLiquidUnit(regionAlias)})`,
                    value: selectedTag.DateTested ? formData?.F1097WaterPsvReliefCapacity : formData?.F1097WaterPsvReliefCapacity ?? selectedTag?.WaterPsvReliefCapacity,
                    xs: 6,
                    marginRight: '0.5rem',
                    textAlignLabel: 'end',
                    height: '1.25rem',
                    readOnly: true,
                    isCalculatedNew: true,
                    labelWidth: '100%',
                    width: '74.5%',
                    textAlign: 'center',
                    borderBottom: formData.F1093TestMedia === 'Gas' && !selectedTag?.NitrogenPsvReliefCapacity ? '0' : '2',
                    type: 'number',
                    maxLength: '10',
                }] : [])
            ]
        },
        {
            key: 7,
            fields: [
                {
                    key: 'F1088DownstreamPressure',
                    label: generateUnitLabel('Downstream Pressure', formData),
                    value: formData.F1088DownstreamPressure,
                    inputWidth: '58%',
                    labelWidth: '100%',
                    xs: 6,
                    marginRight: '0',
                    maxLength: '10',
                    isRequired: true,
                    width: '71.5%',
                    marginLeft: '8px',
                    borderBottom: '0',
                    height: '1.4rem',
                    type: 'number',
                    textAlign: 'center',
                },
                ...(formData.F1093TestMedia === 'Gas' && !selectedTag?.NitrogenPsvReliefCapacity ? [{
                    key: 'F1098WaterEquivalentTestFlow',
                    label: `Water Equivalent Test Flow (${getLiquidUnit(regionAlias)})`,
                    value: WaterEquivalentTestFlowFormula(formData),
                    inputWidth: '58%',
                    labelWidth: '100%',
                    xs: 6,
                    marginRight: '0.5rem',
                    textAlignLabel: 'end',
                    height: '1.25rem',
                    readOnly: true,
                    isCalculatedNew: true,
                    width: '74.5%',
                    textAlign: 'center',
                    type: 'number',
                    maxLength: '10',
                }] : [])
            ]
        },
        {
            key: 8,
            fields: [
                {
                    key: 'F1091FieldReading',
                    label: `Field Reading (${formData?.F603LeakageRateEngUnit ?? ''})`,
                    value: formData.F1091FieldReading,
                    inputWidth: '58%',
                    labelWidth: '100%',
                    xs: 6,
                    marginRight: '0',
                    marginLeft: '8px',
                    isRequired: true,
                    width: '71.5%',
                    height: '1.25rem',
                    textAlign: 'center',
                    type: 'number',
                    maxLength: '10',
                }
            ]
        }
    ]
});
